import { render, staticRenderFns } from "./areas.vue?vue&type=template&id=0e03703a"
import script from "./areas.vue?vue&type=script&lang=js"
export * from "./areas.vue?vue&type=script&lang=js"
import style0 from "./areas.vue?vue&type=style&index=0&id=0e03703a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports